const ADMIN_DOMAINS = ["togglecampus.com", "invector.co", "invector-dev.co"];
const ADMIN_EMAIL_LOCAL_PARTS = ["invector-ai"];

// 관리자는 아니지만 사내 인원이 쓰는 계정 — 분석에서 고객과 섞이지 않게만 구분한다.
// 관리자 화면 권한(isAdminEmail)을 넓히지 않으려고 목록을 따로 둔다.
const INTERNAL_ONLY_DOMAINS = ["demo.com"];
const INTERNAL_ONLY_EMAIL_LOCAL_PARTS = ["baegyutae"];

/** 관리자 화면(설정, 도움말 관리)을 열 수 있는 계정인지. */
export const isAdminEmail = (email: string | null | undefined): boolean =>
  matches(email, ADMIN_DOMAINS, ADMIN_EMAIL_LOCAL_PARTS);

/** 사용 분석에서 고객이 아닌 사내 인원으로 볼 계정인지. 관리자 계정을 모두 포함한다. */
export const isInternalEmail = (email: string | null | undefined): boolean =>
  isAdminEmail(email) ||
  matches(email, INTERNAL_ONLY_DOMAINS, INTERNAL_ONLY_EMAIL_LOCAL_PARTS);

const matches = (
  email: string | null | undefined,
  domains: string[],
  localParts: string[],
): boolean => {
  if (!email) return false;

  const localPart = email.split("@")[0];
  const domain = email.split("@")[1];

  if (domain && domains.includes(domain)) return true;
  if (localPart && localParts.includes(localPart)) return true;

  return false;
};
